<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <div class="container">
        <div class="area_wrap">
          <div class="aw_blank">
            <span class="imgWrap"><img src="@/assets/images/thanq_logo.png"/></span>
            <p>회원님의 아이디는
              <b v-if="GET_ID !== ''">{{GET_ID}} </b>
              <b v-else>{{id}} </b>
              입니다. </p>
            <p>임시 비밀번호를 입력한 메일로 보내드렸습니다. </p>
            <p>로그인 후 '설정'에서 비밀번호를 변경 후 </p>
            <p>사용하시기 바랍니다.</p>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <button type="button" @click.prevent="goLogin()">로그인</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/'
      },
      setCount: false,
      id: ''
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    goLogin () {
      sessionStorage.removeItem('pwFindId')
      this.$router.push('/login')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  computed: {
    ...mapGetters([
      'GET_ID'
    ]),
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  created () {
    const pwFindId = sessionStorage.getItem('pwFindId')
    console.log('pwFindId: ', pwFindId)
    this.id = pwFindId
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('isTemp') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
  }
}
</script>

<style lang="scss" scoped>
</style>
